import React, { useEffect } from "react";
import { useWSModal, WSList, WSLoader } from "@wingspanhq/fe-component-library";
import { WSErrorMessage } from "../../../../components/WSErrorMessage/WSErrorMessage";
import { queriesCards } from "@query";

type ActivateVirtualCardModalProps = {
  onClose: () => void;
  onSuccess: () => void;
  cardId: string;
};

const ActivateVirtualCardModal: React.FC<ActivateVirtualCardModalProps> = ({
  cardId,
  onClose,
  onSuccess
}) => {
  const [activateCard, activateCardMeta] =
    queriesCards.activateCard.useMutation();

  useEffect(() => {
    activateCard({ cardId }, { onSuccess });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cardId]);

  return (
    <WSList gap="L">
      {activateCardMeta.isError ? (
        <WSErrorMessage error={activateCardMeta.error} contextKey="BankCard" />
      ) : (
        <WSLoader.Spinner />
      )}
    </WSList>
  );
};

export const useActivateVirtualCardModal = () =>
  useWSModal(ActivateVirtualCardModal, {
    title: "Activate virtual card",
    size: "S"
  });
